const VERSION = '4.2.2';
export default VERSION;
